export const DATE_FORMAT: string = "DD.MM.YYYY";

export const BACKEND_DATE_FORMAT: string = "YYYY-MM-DD";

export const formatDays = (days: number): string => {
  if (days === 0) return `${days} дней`;
  if (days % 10 === 1 && days % 100 !== 11) return `${days} день`;
  if ([2, 3, 4].includes(days % 10) && ![12, 13, 14].includes(days % 100)) return `${days} дня`;
  return `${days} дней`;
};
